// extracted by mini-css-extract-plugin
export default {"list":"ResumenesLista_list__nZwPm"};